export default __webpack_public_path__ + "3fd3af222d5c7c1d7202de39db84ee3b.svg";